var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"data-cy":"download-incident-report-link"},on:{"click":_vm.downloadIncidentReport}},[_vm._t("default",[_vm._v(_vm._s(_vm.eventId))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }